// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ofbb","newExpiryDate":"styles_newExpiryDate__1MVuA","footer":"styles_footer__2Jm26"};